import TranslationsTemplate from "components/templates/TranslationsTemplate/TranslationsTemplate";

const TranslationsPage = () => {
  return <TranslationsTemplate />;
};

export default TranslationsPage;
